export const FETCH_USER_METADATA_REQUEST = 'FETCH_USER_METADATA_REQUEST'
export const FETCH_USER_METADATA_SUCCESSFUL = 'FETCH_USER_METADATA_SUCCESSFUL'
export const FETCH_USER_METADATA_ERROR = 'FETCH_USER_METADATA_ERROR'

export const fetchUserMetadataRequest = () => {
    return { type: FETCH_USER_METADATA_REQUEST }
}



// WEBPACK FOOTER //
// ./src/actions/userMetadata.js